import { IoIosArrowDroprightCircle } from "react-icons/io";
import { LinkElement, ProjectCardContainer, MainContainer, Heading, LinkContainer, LinkSubContainer,Creds } from './style.js'

const ProjectCard = (props) => {
    const { details } = props
    const { name, image_url, link } = details
    return (
        <ProjectCardContainer>
            <Heading>{name}</Heading>
            <MainContainer link={image_url}>
                <LinkContainer href={link} target="_blank" rel="noreferrer">
                    <LinkSubContainer>
                        <LinkElement>Link</LinkElement>
                        <IoIosArrowDroprightCircle />
                    </LinkSubContainer>
                    <Creds> <br />Username: rahul<br />password: rahul@2021<br/>(registartion page is building)</Creds>
                </LinkContainer>
            </MainContainer>
        </ProjectCardContainer>

    )
}
export default ProjectCard